<template>
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="50%" custom-class="proj-dialog">
      <el-table :data="tableData">
        <el-table-column prop="projectSort" label="序号" min-width="20px"/>
        <el-table-column prop="projectName" label="课程班" min-width="20px"/>
        <el-table-column prop="charge" label="收费（元）" min-width="20px"/>
        <el-table-column prop="coachNum" label="培训次数" min-width="20px"/>
        <el-table-column prop="coachDate" label="培训时间" min-width="40px"/>
        <el-table-column prop="studentNum" label="招生人数" min-width="20px"/>
        <el-table-column  width="60px">
          <template slot-scope="scope">
            <el-button type="text" @click="showSignUp(scope.row)">报名</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
</template>
<script>
  export default {
    name: "ProjectDialog",
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '课程详情',
        tableData:[],
      }
    },
    methods: {
      showDialog(data) {
        this.dialogVisible = true;
        this.tableData = data;
      },
      showSignUp(val) {
        this.$emit('showSignUp', val);
      },
    },
  }
</script>
<style lang="less">
.proj-dialog{
  width: auto;
  max-width: 80%;
  height: 80vh;
  overflow: auto;
  .el-dialog__header {
    padding: 10px;
    background-color: #f3f7fa;
    border-radius: 5px 5px 0 0;
  }
}
</style>
